import MuiAccordion, { AccordionProps as MuiAccordionProps } from "@mui/material/Accordion";
import MuiAccordionActions, { AccordionActionsProps as MuiAccordionActionsProps } from "@mui/material/AccordionActions";
import MuiAccordionSummary, { AccordionSummaryProps as MuiAccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails, { AccordionDetailsProps as MuiAccordionDetailsProps } from "@mui/material/AccordionDetails";

export type AccordionProps = MuiAccordionProps;

const Accordion: React.FC<AccordionProps> = (props) => {
  return <MuiAccordion {...props}>{props.children}</MuiAccordion>;
};

export type AccordionActionsProps = MuiAccordionActionsProps;

export const AccordionActions: React.FC<AccordionActionsProps> = (props) => {
  return <MuiAccordionActions {...props}>{props.children}</MuiAccordionActions>;
};

export type AccordionSummaryProps = MuiAccordionSummaryProps;

export const AccordionSummary: React.FC<AccordionSummaryProps> = (props) => {
  return <MuiAccordionSummary {...props}>{props.children}</MuiAccordionSummary>;
};

export type AccordionDetailsProps = MuiAccordionDetailsProps;

export const AccordionDetails: React.FC<AccordionDetailsProps> = (props) => {
  return <MuiAccordionDetails {...props}>{props.children}</MuiAccordionDetails>;
};

export default Accordion;
